'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _shopifySectionsManager = require('shopify-sections-manager');

var _shopifySectionsManager2 = _interopRequireDefault(_shopifySectionsManager);

var _StaticCart = require('../sections/StaticCart');

var _StaticCart2 = _interopRequireDefault(_StaticCart);

require('intersection-observer');

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

var _loadjs = require('loadjs');

var _loadjs2 = _interopRequireDefault(_loadjs);

require('../../styles/templates/cart.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scriptsEl = document.querySelector('[data-scripts]');
var scripts = JSON.parse(scriptsEl.innerHTML);

var Cart = function Cart() {
  (0, _classCallCheck3.default)(this, Cart);

  var sections = window.shopifySections || new _shopifySectionsManager2.default();
  sections.register('static-cart', function (section) {
    return new _StaticCart2.default(section);
  });

  _rimgShopify2.default.init();
};

exports.default = Cart;


(0, _loadjs2.default)([scripts.shopify_common], function () {
  new Cart();
});